// La richiesta che apre una sessione, letta per la chat (2026-11-02, «tutta la parte iniziale
// dovrebbe essere messa dentro un file allegato … e nel testo un sunto della richiesta»): quando è
// lunga o divisa in sezioni la chat mostra il sunto e il testo intero come allegato. Il testo che
// ricevono i pop non cambia.

export interface RequestDigest {
  /** il titolo (`# …`), se c'è */
  title: string | null;
  /** cosa si chiede: la frase che segue le sezioni, o l'inizio del testo */
  ask: string;
  /** i nomi delle sezioni (`## …`) */
  sections: string[];
}

/** Oltre questa lunghezza una richiesta senza sezioni diventa comunque un allegato. */
export const LONG_REQUEST = 800;
const ASK_MAX = 280;

function clip(text: string): string {
  const flat = text.replace(/\s+/g, ' ').trim();
  return flat.length > ASK_MAX ? `${flat.slice(0, ASK_MAX - 1).trimEnd()}…` : flat;
}

const isList = (p: string) => /^(\s*([-*+]|\d+\.)\s)/.test(p);

/** null quando la richiesta è breve e si legge bene così com'è. */
export function digestRequest(text: string): RequestDigest | null {
  const lines = text.split('\n');
  const sections = lines.filter((l) => /^##\s+\S/.test(l)).map((l) => l.replace(/^##\s+/, ''));
  if (sections.length === 0 && text.length <= LONG_REQUEST) return null;
  const title = lines.find((l) => /^#\s+\S/.test(l))?.replace(/^#\s+/, '') ?? null;

  const paragraphs = text
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);
  const lastHeading = paragraphs.reduce((at, p, i) => (/^#{1,6}\s/.test(p) ? i : at), -1);
  // dopo l'ultima sezione: il suo contenuto (testo o elenco), poi la richiesta vera e propria
  // (se il titolo ha il contenuto attaccato, senza riga vuota, quel contenuto è già nel suo blocco)
  const body = lastHeading >= 0 && paragraphs[lastHeading].includes('\n') ? 1 : 2;
  const after = paragraphs
    .slice(lastHeading + body)
    .find((p) => !isList(p) && !/^#{1,6}\s/.test(p) && !/^Contesto:/i.test(p));
  const first = paragraphs.find((p) => !/^#{1,6}\s/.test(p)) ?? text;
  return { title, ask: clip(after ?? first), sections };
}
